// returns the start of the month in n months (1 = next month, 2 = next month, etc.)

const getStartOfMonth = (
  date: Date = new Date(),
  offsetMonths: number = 0,
): Date => new Date(date.getFullYear(), date.getMonth() + offsetMonths, 1);

export default getStartOfMonth;
